import { useImporterViewModel } from '../ImporterViewModel'
import { DetailedImportView } from './DetailedImportView'
import { ProcessType } from './types'

export function ImportWizardStartImportStep({
  show,
  onImportTags,
  onImportDeals,
  onImportContacts,
  onImportNotes,
  isProcessing,
  currentProcess,
}: {
  show: boolean
  onImportTags: () => void
  onImportDeals: () => void
  onImportContacts: () => void
  onImportNotes: () => void
  isProcessing: boolean
  currentProcess: ProcessType | null
}) {
  const viewModel = useImporterViewModel()

  if (!show) {
    return null
  }

  return (
    <DetailedImportView
      show={show}
      viewModel={viewModel}
      onImportTags={onImportTags}
      onImportDeals={onImportDeals}
      onImportContacts={onImportContacts}
      onImportNotes={onImportNotes}
      isProcessing={isProcessing}
      currentProcess={currentProcess}
    />
  )
}
